package diana.soleil.design.iraniancanadienbazzar.feature.admin

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for the admin-lite feature. Aggregated by the app composition root. */
val adminModule = module {
    viewModel { AdminViewModel(get(), get()) }
    viewModel { CampaignViewModel(get()) }
}
